const topologiesConfig = {
  "/ents/orgs/sites/topology.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/topology",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "topology",
  },
  "/orgs/sites/topology.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/topology",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "topology",
  },
}

export default topologiesConfig;